import { InputHTMLAttributes, useRef } from 'react';
import ClearIcon from '~/icons/iconography/close.svg';
import LoopIcon from '~/icons/search.svg';
import { ClearButton, Input, SearchButton, SearchText } from './styles';

type Props = {
    setInputValue: (value: string) => void;
} & InputHTMLAttributes<HTMLInputElement>;

export default function SearchField({ value, setInputValue, ...rest }: Props) {
    const searchFieldRef = useRef<HTMLInputElement>(null);

    return (
        <SearchText>
            <SearchButton aria-label="Klik for at søge">
                <LoopIcon />
            </SearchButton>
            <Input
                value={value}
                onChange={(e) => setInputValue(e.target.value)}
                ref={searchFieldRef}
                {...rest}
            />

            <ClearButton
                aria-hidden={!value}
                aria-label="Slet søgning"
                tabIndex={!value ? -1 : undefined}
                onClick={() => {
                    searchFieldRef.current?.focus();
                    setInputValue('');
                }}
            >
                <ClearIcon />
            </ClearButton>
        </SearchText>
    );
}
